import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import useMergeProps from '../../../../hooks/useMergeProps';
import { StateType } from '../../../../states';
import GRBetslipEligibleHeadband from '../GRBetslipBand/GRBetslipBand';

import selectGRBasketBetslipHeadbandProps from './GRBasketBetslipBand.selector';

type GRBasketBetslipEligibleHeadBandContainerProps = {
  className?: string;
  oddsId?: number;
};

const GRBasketBetslipEligibleHeadBandContainer = ({
  oddsId,
  ...ownProps
}: GRBasketBetslipEligibleHeadBandContainerProps) => {
  const selectorProps = useMemo(() => ({ oddId: oddsId }), [oddsId]);
  const selector = useMemo(() => selectGRBasketBetslipHeadbandProps(), []);
  const { isVisible, ...selectedProps } = useSelector((state: StateType) => selector(state, selectorProps));

  const { label, ...enhancedProps } = useMergeProps({ ownProps, selectedProps });

  if (label) {
    return isVisible ? <GRBetslipEligibleHeadband {...enhancedProps} label={label} /> : null;
  }

  return null;
};

export default GRBasketBetslipEligibleHeadBandContainer;
